<template>
  <div>
    <div class="fixed-plugin" v-click-outside="closeDropDown">
      <div class="dropdown show-dropdown" :class="{ show: isOpen }">
        <a data-toggle="dropdown">
          <i class="fa fa-cog fa-2x" @click="toggleDropDown"> </i>
        </a>
        <ul class="dropdown-menu" :class="{ show: isOpen }">
          <p class="header">{{ $t("sidebar.settings") }}</p>
          <li class="flex" @click="showTimezoneModal">
            <i class="fas fa-clock"></i>
            <span>{{ $t("timezone.timezone") }}</span>
          </li>
          <li class="flex" @click.prevent="showChangePasswordModal()">
            <i class="fas fa-unlock-alt"></i>
            <span>{{ $t("common.change_password") }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <isis-timezone-modal v-if="isShowTimezoneModal"></isis-timezone-modal>
      <div v-if="isShowModal">
        <change-password
          :name="changePasswordModal.name"
          :title="changePasswordModal.title"
          :uuid="info.uuid"
        ></change-password>
      </div>
    </div>
  </div>
</template>
<script>
import IsisTimezoneModal from "@/components/IsisTimezoneModal";
import ChangePassword from "./ChangePassword";
import { mapGetters } from "vuex";

export default {
  components: { IsisTimezoneModal, ChangePassword },
  data() {
    return {
      isShowTimezoneModal: false,
      isOpen: false,
      //change password
      isShowModal: false,
      changePasswordModal: {
        name: "change-password-my-account",
        title: "common.change_password"
      }
    };
  },
  computed: {
    ...mapGetters("user", ["info"])
  },
  methods: {
    showTimezoneModal() {
      this.closeDropDown();
      this.isShowTimezoneModal = true;
    },
    showChangePasswordModal() {
      this.isShowModal = true;
      this.$nextTick(() => {
        this.$modal.show(this.changePasswordModal.name);
      });
      this.closeDropDown();
    },
    toggleDropDown() {
      this.isOpen = !this.isOpen;
      this.isShowTimezoneModal = false;
      this.isShowModal = false;
    },
    closeDropDown() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.header {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  padding: 10px 0px 10px;
  margin: 0 !important;
}

ul {
  li {
    height: 40px;
    width: 100% !important;
    border-radius: 5px;
    margin-bottom: 10px;
    line-height: 30px;

    &:hover {
      background-color: #dddddd;
      transform: scale(1.02);
    }

    i {
      line-height: 30px;
      font-size: 20px;
      padding: 0 20px 0 10px;
    }

    span {
    }
  }
}
</style>
